import "./CompanyOnboardin.css";
import axios from "axios";
import { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Link } from "react-router-dom";
//
import { collection, addDoc } from "firebase/firestore";
import { db as database } from "./firebase";
//
export default function CompanyOnboardin(e) {
  const [onboardingButton, setOnboardingButton] = useState("Onboard stripe");
  const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);
  const handleOnboard = async (e) => {
    e.preventDefault();
    setOnboardingButton("Connecting Stripe...");
    axios
      .post(process.env.REACT_APP_STRIPE_SELLER_ONBOARDING_URL)
      .then((response) => {
        saveAccIDToDatabase(response.data.connectedAccountId);
        window.location.href = response.data.url;
      })
      .catch((error) => {
        console.error("Error posting data:", error);
      });
  };
  async function saveAccIDToDatabase(StripeConnectedAccountId) {
    try {
      const createdAt = new Date().getTime();
      const id = createdAt;
      const connectedAccountIdItem = {
        connectedAccountId: StripeConnectedAccountId,
        createdAt: createdAt,
      };
      //
      ///////////////////////////////////////////////////////////////////////////
      const docRef = await addDoc(
        collection(database, "Seller"),
        connectedAccountIdItem
      );
      alert.show("connectedAccountId saved correctly !");
    } catch (error) {
      // console.log(error);
      alert.show(error);
    }
  }
  return (
    <>
      <div className="container">
        <p className="instruction">
          Click the button bellow to activate
          <Link
            className="stripe_link"
            to="https://stripe.com/"
            title="Amazon, shopify, airbnb use Stripe for online payment processing"
          >
            {` Stripe `}
          </Link>
          for processing Customer payments and make transfers into your bank
          account :
        </p>
        <button
          className="button"
          onClick={handleOnboard}
          disabled={!stripePromise}
        >
          {onboardingButton}
        </button>
      </div>
    </>
  );
}
